export default __webpack_public_path__ + "static/media/Locandina Percorso.27d689fc.jpg";